import {
  InvoiceExportEntity,
  InvoiceExportParamsEntity,
} from "../../entities/InvoiceExportEntity";
import { InvoiceExportRepository } from "../../repositories/InvoiceExportRepository";

export class DownloadInvoiceExportExcelUseCase {
  constructor(private repository: InvoiceExportRepository) {}

  async execute(
    params: InvoiceExportParamsEntity = {},
  ): Promise<InvoiceExportEntity> {
    const from = params.fromDate?.trim() || "";
    const to = params.toDate?.trim() || "";

    if ((from && !to) || (!from && to)) {
      throw new Error("Please select both From date and To date.");
    }
    if (from && to && from > to) {
      throw new Error("From date must be before or equal to To date.");
    }

    return await this.repository.downloadInvoiceExportExcel({
      fromDate: from || undefined,
      toDate: to || undefined,
    });
  }
}

